import { useMemo } from "react";
import {
  DISBURSEMENTS_METHOD_TYPES,
  DISBURSEMENTS_STATUS,
  PAYEE_TYPES,
} from "../../../../../../../../../lib/constants";

export const useInitialFormValues = () => {
  const initial = useMemo(
    () => ({
      enableForPayments: true,
      type: PAYEE_TYPES[0].value,
      method: DISBURSEMENTS_METHOD_TYPES[0].value,
      status: DISBURSEMENTS_STATUS[0].value,
      amountSwitcher: 2,
    }),
    [],
  );

  return { initial };
};
